import {Fragment} from "react";
import BasicModal from "../../../../../common/BasicModal";
import AddCustomFieldContainer from "./AddCustomFieldContainer";

export default function AddCustomFieldModal({title, msgDataSourceId,open, handleClose}) {

    return (
        <Fragment>
            <BasicModal
                title={title}
                open={open}
                style={{width: '500px'}}
                handleClose={handleClose}>

                <AddCustomFieldContainer
                    msgDataSourceId={msgDataSourceId}
                    handleClose={handleClose}
                />
            </BasicModal>
        </Fragment>
    )
}